import BankAccountsPage from '@/pages/bankAccounts/CMBankAccountsPage.vue'
import EditBankAccount from '@/pages/bankAccounts/CMEditBankAccount.vue'
import CreateBankAccount from '@/pages/bankAccounts/CMAddBankAccount.vue'
import ImportBankAccount from '@/pages/bankAccounts/CMImportBankAccount.vue'
import ImportBankAccountReport from '@/pages/bankAccounts/CMImportBankAccountReport.vue'
import ListStatementBankAccount from '@/pages/bankAccounts/CMListStatementBankAccount.vue'
import RapprochementManuel from '@/pages/bankAccounts/RapprochementManuel.vue'

export default [
  {
    path: '/bankAccounts/',
    alias: ['/account/bankAccounts/'],
    component: BankAccountsPage
  },
  {
    path: '/bankAccounts/modify/',
    alias: ['/account/bankAccounts/modify/'],
    component: EditBankAccount
  },
  {
    path: '/bankAccounts/create/',
    alias: ['/account/bankAccounts/create/'],
    component: CreateBankAccount
  },
  {
    path: '/bankAccounts/import/',
    alias: ['/account/bankAccounts/import/'],
    component: ImportBankAccount
  },
  {
    path: '/bankAccounts/importReport/',
    alias: ['/account/bankAccounts/importReport/'],
    component: ImportBankAccountReport
  },
  {
    path: '/bankAccounts/listStatement/',
    alias: ['/account/bankAccounts/listStatement/'],
    component: ListStatementBankAccount
  },
  {
    path: '/bankAccounts/rapprochement',
    component: RapprochementManuel
  }
]



// WEBPACK FOOTER //
// ./src/routes/bankAccounts.js